import * as React from 'react';
import ReactDom from 'react-dom';
import { emporiModule } from '@empori/util';
import { CaseStudies } from './components/caseStudies';
import { NewsArchive } from './components/newsArchive';
import { Logotypes } from './components/logotypes';
import { alterForms } from './fns/alterForms';
import { Testimonials } from './components/testimonials';
import { demoPopup } from './fns/demoPopup';
import { rowAnimation } from './fns/rowAnimation';
import { mainNav } from './fns/mainNav';
emporiModule('autonetLoaded', {
    autonet: {
        InitCaseStudies: function (element, items) {
            ReactDom.render(React.createElement(CaseStudies, { items: items }), element);
        },
        InitNewsArchive: function (element, items, loadMoreLabel) {
            ReactDom.render(React.createElement(NewsArchive, { items: items, loadMoreLabel: loadMoreLabel }), element);
        },
        InitLogotypeSlideshow: function (element, items, loadMoreLabel) {
            ReactDom.render(React.createElement(Logotypes, { items: items, loadMoreLabel: loadMoreLabel }), element);
        },
        InitFormsAltering: function (culture) {
            alterForms(culture);
        },
        InitTestimonials: function (element, items, readOnLabel, closeLabel) {
            ReactDom.render(React.createElement(Testimonials, { items: items, readOnLabel: readOnLabel, closeLabel: closeLabel }), element);
        },
        InitDemoPopUp: function (element) {
            demoPopup(element);
        },
        InitRowAnimation: function () {
            rowAnimation();
        },
        InitMainNav: function (element) {
            mainNav(element);
        }
    }
});
